export const isColorDark = (hex) => {
  if (!hex) return false;
  const c = hex.replace('#', '');
  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 < 128;
};

export const formatPrice = (cents) => {
  if (!cents) return null;
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
};

export const buildTheme = (shop) => {
  const accentColor = shop.accentColor || '#F59E0B';
  const headerColor = shop.headerColor || '#FFFFFF';
  const pageBg = shop.backgroundColor || '#F9FAFB';
  const cardBg = shop.cardColor || '#FFFFFF';
  const textColor = shop.textColor || '#111827';
  const isDark = isColorDark(pageBg);
  const borderColor = isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)';
  const mutedText = isDark ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)';
  return { pageBg, cardBg, textColor, headerColor, accentColor, borderColor, mutedText, isDark };
};
